class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.timerIn;
    this.timerOut;
    this.header = document.querySelector('.header-wrapper');
    this.isOpen = false; // Flag to track submenu state
    this.mainDetailsToggle.addEventListener('mouseout', this.onMouseOut.bind(this));
    this.mainDetailsToggle.addEventListener('mouseover', this.onMouseOver.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    this.mainDetailsToggle.querySelector('.mega-menu__content').classList.toggle('open', this.mainDetailsToggle.hasAttribute('open'));

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }

  onMouseOver() {
    clearTimeout(this.timerOut);
    if (this.isOpen) return; // Prevent opening if already open
    this.timerIn = setTimeout(() => {
      this.mainDetailsToggle.setAttribute('open', true);
      this.isOpen = true; // Set flag to true when submenu is open
    }, 100);
  }

  onMouseOut() {
    clearTimeout(this.timerIn);
    if (!this.isOpen) return; // Prevent closing if already closed
    this.timerOut = setTimeout(() => {
      this.mainDetailsToggle.removeAttribute('open');
      this.isOpen = false; // Set flag to false when submenu is closed
    }, 100);
  }
}

customElements.define('header-menu', HeaderMenu);
